// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a7f83f9","833":"a2451765"}[chunkId] + ".chunk.js";
};